[
  {
    "id": "Robin",
    "name": "Robin's Project",
    "requester": "Robin",
    "type": "town",
    "text": "I have an idea for a new style of bed. I just need some extra hardwood.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Collect 80 Hardwood",
    "rewards": "2,000g; 250 Friendship points with Robin; cutscene at Robin's house; Deluxe Red Double Bed available",
    "repeatable": false
  },
  {
    "id": "Robin2",
    "name": "Robin's Resource Rush",
    "requester": "Robin",
    "type": "town",
    "text": "I'm putting on a little promotion, just for fun. Whoever brings me the most resources wins a prize.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Collect 1,000 of: Wood or Stone",
    "rewards": "2,500g, Stone Chest recipe",
    "repeatable": true
  },
  {
    "id": "Demetrius",
    "name": "Aquatic Overpopulation",
    "requester": "Demetrius",
    "type": "town",
    "text": "For unknown reasons, the local population of fish has grown to an unsustainable level. Can you help restore balance?",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Catch 10 seasonal fish",
    "rewards": "Gold (fish sell value), Farm Computer recipe",
    "repeatable": true
  },
  {
    "id": "Demetrius2",
    "name": "Biome Balance",
    "requester": "Demetrius",
    "type": "town",
    "text": "For unknown reasons, the local population of fish has grown to an unsustainable level. A broader variety is needed.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Catch 20 of: River Fish, Ocean Fish, or Lake Fish",
    "rewards": "1,500g, Farm Computer recipe",
    "repeatable": true
  },
  {
    "id": "Linus",
    "name": "Community Cleanup",
    "requester": "Linus",
    "type": "town",
    "text": "I have an idea. There's a lot of trash in the water around town. Want to help clean it up?",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Gather 20 trash items and dump them in the bin at the train platform",
    "rewards": "500g; 250 Friendship points with Linus; Fiber Seeds recipe; cutscene at Mountain Lake",
    "repeatable": false
  },
  {
    "id": "Emily",
    "name": "Rock Rejuvenation",
    "requester": "Emily",
    "type": "town",
    "text": "I'm going to invite some friends over to do a rock rejuvenation ceremony. I need some special gems.",
    "prerequisites": "Access to Sewing Machine in Emily's house",
    "timeframe": 7,
    "requirements": "Deliver 1 each of: Ruby, Topaz, Emerald, Jade, Amethyst",
    "rewards": "1,000g; 250 Friendship points with Emily; Sewing Machine; ceremony cutscene",
    "repeatable": false
  },
  {
    "id": "Gunther",
    "name": "Fragments of the Past",
    "requester": "Gunther",
    "type": "town",
    "text": "Calling all amateur paleontologists! Bring any bone-related artifacts or items to the Museum.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Collect 100 bone items and deposit them in the Museum box",
    "rewards": "3,500g, Bone Mill recipe",
    "repeatable": false
  },
  {
    "id": "Pam",
    "name": "Pam Needs Juice",
    "requester": "Pam",
    "type": "town",
    "text": "Heard there's a spirit made out of potatoes. Think you could bring me some potato juice?",
    "prerequisites": "Spring season",
    "timeframe": 14,
    "requirements": "Place 12 Potato Juice in Pam's kitchen",
    "rewards": "3,000g; 250 Friendship points with Pam; Potato Juice cutscene; F.I.B.S. TV channel",
    "repeatable": false
  },
  {
    "id": "Gus",
    "name": "Gus' Famous Omelet",
    "requester": "Gus",
    "type": "town",
    "text": "I've got the urge to make my famous giant omelet. I'll need a lot of eggs.",
    "prerequisites": null,
    "timeframe": 14,
    "requirements": "Place 24 Eggs into Stardrop Saloon fridge",
    "rewards": "3,000g; Mini-Fridge (first time); Giant Omelet cutscene (first time)",
    "repeatable": true
  },
  {
    "id": "Pierre",
    "name": "Pierre's Prime Produce",
    "requester": "Pierre",
    "type": "town",
    "text": "For an upcoming promotion, I'm thinking of offering some high-quality vegetables.",
    "prerequisites": null,
    "timeframe": 28,
    "requirements": "Dump 25 Gold-quality vegetables in the bin at General Store",
    "rewards": "2,500g, cutscene at General Store, Mini-Shipping Bin by mail",
    "repeatable": false
  },
  {
    "id": "Lewis",
    "name": "Crop Order",
    "requester": "Lewis",
    "type": "town",
    "text": "Crops are in high demand this year. Ship a large batch of a seasonal crop.",
    "prerequisites": "Not Winter season",
    "timeframe": 28,
    "requirements": "Ship 100 of a seasonal crop",
    "rewards": "Gold (50% base quality crop price); Mini-Shipping Bin by mail (first time)",
    "repeatable": true
  },
  {
    "id": "Willy",
    "name": "Juicy Bugs Wanted!",
    "requester": "Willy",
    "type": "town",
    "text": "I'm looking for a big wad o' bug guts to use as fishing bait.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Gather 100 Bug Meat and dump it in the bin next to the fish shop",
    "rewards": "3,000g, Quality Bobber recipe, cutscene at The Beach",
    "repeatable": false
  },
  {
    "id": "Willy2",
    "name": "Tropical Fish",
    "requester": "Willy",
    "type": "town",
    "text": "There's nothin' like tropical fishing. I'd love some fresh catches from Ginger Island.",
    "prerequisites": "Ginger Island unlocked; Island Resort built",
    "timeframe": 7,
    "requirements": "Catch 5 each of: Stingray, Blue Discus, Lionfish",
    "rewards": "2,500g, Deluxe Fish Tank",
    "repeatable": false
  },
  {
    "id": "Wizard",
    "name": "A Curious Substance",
    "requester": "Wizard",
    "type": "town",
    "text": "I seek an extremely rare and powerful goop, known as ectoplasm. Bring it to me.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Collect 1 Ectoplasm",
    "rewards": "2,500g, Mini-Obelisk recipe",
    "repeatable": false
  },
  {
    "id": "Wizard2",
    "name": "Prismatic Jelly",
    "requester": "Wizard",
    "type": "town",
    "text": "I require assistance in tracking down the rare and dangerous prismatic slime.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Collect 1 Prismatic Jelly",
    "rewards": "5,000g, Monster Musk recipe",
    "repeatable": false
  },
  {
    "id": "Caroline",
    "name": "Island Ingredients",
    "requester": "Caroline",
    "type": "town",
    "text": "I want to experiment with tropical cooking. Could you ship me some ingredients from Ginger Island?",
    "prerequisites": "Ginger Island unlocked",
    "timeframe": 28,
    "requirements": "Ship 100 of: Taro Root, Ginger, or Pineapple",
    "rewards": "Gold (50% base crop price), Solar Panel recipe",
    "repeatable": true
  },
  {
    "id": "Clint",
    "name": "Cave Patrol",
    "requester": "Clint",
    "type": "town",
    "text": "The number of monsters in the local caves have made mining dangerous. Would you help thin out their numbers?",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Slay 50 of: Bats, Dust Sprites, Skeletons, or Grubs",
    "rewards": "6,000g; Geode Crusher recipe (first time); Explosives and food by letter (subsequent times)",
    "repeatable": true
  },
  {
    "id": "Evelyn",
    "name": "Gifts for George",
    "requester": "Evelyn",
    "type": "town",
    "text": "George thinks no one in town cares about him. Let's show him that isn't true.",
    "prerequisites": "Spring season",
    "timeframe": 28,
    "requirements": "Collect and place 12 Leeks onto Evelyn's stove",
    "rewards": "2,000g, Coffee Maker, cutscene at George's house",
    "repeatable": false
  },
  {
    "id": "QiChallenge2",
    "name": "Qi's Crop",
    "requester": "Qi",
    "type": "qi",
    "text": "I've hidden Qi Beans throughout the world. Find them, grow them, propagate them, and ship the results.",
    "prerequisites": null,
    "timeframe": 28,
    "requirements": "Ship 500 Qi Fruit using the Shipping Bin",
    "rewards": "100 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge3",
    "name": "Let's Play A Game",
    "requester": "Qi",
    "type": "qi",
    "text": "Think you can score 50,000 points in Junimo Kart endless mode? Impress me.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Score 50,000 points in Junimo Kart endless mode",
    "rewards": "20 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge4",
    "name": "Four Precious Stones",
    "requester": "Qi",
    "type": "qi",
    "text": "Find 4 prismatic shards. Place them in my collection box.",
    "prerequisites": null,
    "timeframe": 28,
    "requirements": "Collect 4 Prismatic Shards (must be collected while quest is active)",
    "rewards": "40 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge5",
    "name": "Skull Cavern Invasion",
    "requester": "Qi",
    "type": "qi",
    "text": "The Skull Cavern has been invaded by powerful monsters. Make it to floor 100.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Make it to floor 100 of the Skull Cavern (Staircases allowed)",
    "rewards": "40 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge6",
    "name": "The Strong Stuff",
    "requester": "Qi",
    "type": "qi",
    "text": "Ship quality items worth a total of at least 100,000g.",
    "prerequisites": null,
    "timeframe": 14,
    "requirements": "Ship items with quality stars worth a total of at least 100,000g",
    "rewards": "25 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge7",
    "name": "Qi's Kindness",
    "requester": "Qi",
    "type": "qi",
    "text": "Give 50 loved gifts in one week.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Give 50 loved gifts to villagers within one week",
    "rewards": "40 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge8",
    "name": "Extended Family",
    "requester": "Qi",
    "type": "qi",
    "text": "Family members of the legendary fish have returned to the valley. Catch them all.",
    "prerequisites": null,
    "timeframe": 3,
    "requirements": "Catch Ms. Angler, Glacierfish Jr., Son of Crimsonfish, Radioactive Carp, and Legend II",
    "rewards": "20 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge9",
    "name": "Danger In The Deep",
    "requester": "Qi",
    "type": "qi",
    "text": "The mine elevator system has been reset, and new dangers have emerged. Reach the bottom again.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Reach the bottom of the Mines (Staircases allowed); resets unlocked Adventurer's Guild gear",
    "rewards": "50 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge10",
    "name": "Qi's Hungry Challenge",
    "requester": "Qi",
    "type": "qi",
    "text": "Your task is to make it to level 100 in the Skull Cavern without consuming any food or drink.",
    "prerequisites": null,
    "timeframe": 7,
    "requirements": "Reach floor 100 of Skull Cavern without consuming food or drink (Staircases allowed)",
    "rewards": "25 Qi Gems",
    "repeatable": true
  },
  {
    "id": "QiChallenge12",
    "name": "Qi's Prismatic Grange",
    "requester": "Qi",
    "type": "qi",
    "text": "Find 100 each of red, orange, yellow, green, blue, and purple items and place them in my collection box.",
    "prerequisites": null,
    "timeframe": 14,
    "requirements": "Place 100 each of red, orange, yellow, green, blue, and purple items in Qi's collection box (600 items total)",
    "rewards": "35 Qi Gems",
    "repeatable": true
  }
]
